import { imageQuality } from '@repo/sanity/image'
import { ShopProduct } from '@repo/shop/types'
import { getDiscount, getPriceAmount, getPriceCurrency } from '@repo/shopify/price'
import { Button } from '@repo/ui/components/button'
import PriceWithDiscount from '@repo/ui/components/price-with-discount'
import { cn } from '@repo/ui/lib/utils'
import { createHrefForDocument } from '@repo/url/href'
import { Image } from 'next-sanity/image'
import Link from 'next/link'
import { FunctionComponent } from 'react'
import { PageDto } from '../../types/page.types'

interface Props {
  pageDto: PageDto
  product: ShopProduct
  onClick?: () => void
  onRemove?: (urlSlug: string) => void
  className?: string
}

const CartProduct: FunctionComponent<Props> = ({ pageDto, product, onClick, onRemove, className }) => {
  const title = String(product.sanityProduct.title)
  const urlSlug = product.sanityProduct.urlSlug?.current || ''
  const amount = getPriceAmount(product.shopifyProduct)
  const currencyCode = getPriceCurrency(product.shopifyProduct)
  const discount = getDiscount(product.shopifyProduct)
  const href = createHrefForDocument('product', urlSlug, pageDto.params.locale)

  return (
    <li className={cn('flex shrink-0 flex-col gap-2 overflow-hidden text-sm uppercase', className)}>
      <Link className='bg-card relative aspect-[2/3] overflow-hidden rounded-lg' href={href} onClick={onClick} title={title}>
        {product.sanityProduct.thumbnails?.[0]?.asset?.url && (
          <Image
            fill={true}
            sizes='10rem'
            priority={false}
            quality={imageQuality}
            className='object-cover'
            src={product.sanityProduct.thumbnails[0].asset.url}
            alt={product.sanityProduct.thumbnails?.[0]?.alt || title || ''}
            blurDataURL={product.sanityProduct.thumbnails?.[0]?.asset?.metadata?.lqip ?? undefined}
            placeholder={product.sanityProduct.thumbnails?.[0]?.asset?.metadata?.lqip ? 'blur' : undefined}
          />
        )}
      </Link>
      <div className='flex flex-col gap-1 px-1.5'>
        <h3 className='truncate' title={title || undefined}>
          {title}
        </h3>
        <PriceWithDiscount className='flex items-center' amount={amount} discount={discount} currencyCode={currencyCode} />
        {onRemove && (
          <Button variant='linkAuto' size='sm' type='button' className='w-fit p-0 underline' onClick={() => onRemove(urlSlug)}>
            {pageDto.dictionary?.navigation?.remove || 'Remove'}
          </Button>
        )}
      </div>
    </li>
  )
}

export default CartProduct
